function initializeVelinaBundleFit(section) {
  if (section.dataset.ready) return;
  section.dataset.ready = 'true';
  const bundle = section.querySelector('[data-bundle-form]');
  const addButton = bundle.querySelector('button');
  const error = bundle.querySelector('[data-bundle-error]');
  addButton.disabled = false;

  bundle.addEventListener('submit', async event => {
    event.preventDefault();
    if (addButton.disabled) return;
    const data = new FormData(bundle);
    const items = ['first', 'second'].map(name => ({
      id: Number(data.get(name)),
      quantity: 1
    }));
    if (items.some(item => !Number.isSafeInteger(item.id) || item.id <= 0)) return;
    addButton.disabled = true;
    error.hidden = true;
    try {
      const response = await fetch(bundle.dataset.addUrl, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items})
      });
      if (!response.ok) throw new Error('Unable to add bundle');
      window.location.assign(bundle.dataset.cartUrl);
    } catch {
      error.hidden = false;
      addButton.disabled = false;
    }
  });

  const fit = section.querySelector('[data-length-form]');
  const result = fit.querySelector('[data-length-result]');
  const outside = fit.querySelector('[data-length-outside]');
  fit.querySelector('button').disabled = false;
  fit.addEventListener('submit', event => {
    event.preventDefault();
    const data = new FormData(fit);
    const length = Number(data.get('length'));
    const centimetres = data.get('unit') === 'cm';
    const inches = centimetres ? length / 2.54 : length;
    const inRange = centimetres ? length >= 132.1 && length <= 157.5 : inches >= 52 && inches <= 62;
    result.hidden = !inRange;
    outside.hidden = inRange;
    if (inRange) result.querySelector('[data-length-size]').textContent =
      Math.min(62, Math.max(52, 2 * Math.round(inches / 2)));
  });
}

document.querySelectorAll('[data-vbf]').forEach(initializeVelinaBundleFit);
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('[data-vbf]').forEach(initializeVelinaBundleFit);
});